module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      India Edghill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("India Edghill")]), _vm._v(" is a librarian living in the mid-Hudson Valley, New York.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PlZIjE/tc-custom/9781466821378.jpg?1720280500460",
      "alt": "This image is the cover for the book Wisdom's Daughter"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wisdom's Daughter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("This is the tale of Bilqis, the Queen of Sheba, who rules the spice lands and bows before the will of the Goddess.")]), _c('br'), _c('br'), _c('i', [_vm._v("This is the tale of Solomon, the King of Israel and Judea, who built the golden temple to Yahweh in Jerusalem. Once he prayed that he might rule wisely.")]), _c('br'), _c('br'), _c('i', [_vm._v("This is the tale of Solomon's wives, of his concubines ... and of his daughter Baalit, more beloved than any son. Here are their voices, their mysteries, and their deepest secrets. Here they sing their songs and weave their tapestries.")]), _c('br'), _c('br'), _vm._v("As the queen's search for a true heir to her throne takes her to the court of the wisest man in the world, both she and the king learn how to value truth, love, and duty...and the king's daughter learns that not all the world is ruled by men."), _c('br'), _c('br'), _c('i', [_vm._v("Wisdom's Daughter")]), _vm._v(" is a vivid and richly textured rendition of the biblical tale of King Solomon and the Queen of Sheba.  Told in a tapestry of voices that ring with authenticity, "), _c('i', [_vm._v("Wisdom's Daughter")]), _vm._v(" profoundly reveals the deep ties among women in a patriarchal world.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0